import { PaginationType, PostType, SlideType, userType } from "../../../DTO";
import { Api } from "../../api";
import { convertToPaginationType } from "../../help";
import { convertToSlideType } from "./create";

export const ListSlide = (
    user: userType,
    lessonId: number,
    currentPage: number,
) => {
    return new Promise<{ slides: SlideType; pagination: PaginationType }>(
        (resolve, reject) => {
            const api = new Api({
                method: "get",
                path: `lesson/${lessonId}/slides`,
                header: {
                    Authorization: `Bearer ${user.access_token}`,
                },
                params: {
                    page: currentPage,
                },
            });

            return api
                .call()
                .then((data: any) =>
                    resolve({
                        slides: convertToSlideType(data),
                        pagination: convertToPaginationType(data.data),
                    }),
                )
                .catch((error: any) => reject(error.data.message));
        },
    );
};
